<div class="h-100 d-flex flex-column justify-content-between">
  <nav
    [ngClass]="{ hidden: navToggle && hidden }"
    [ngStyle]="{ width: navToggle && hidden ? '3rem' : size + 'ch' }"
    class="nav-fases-processo"
  >
    <ng-content select="[header]"></ng-content>
    <ng-container *ngFor="let link of links; let i = index">
      <hr *ngIf="link.spacer" />
      <button
        *ngIf="!link.spacer"
        (click)="emitActive(i)"
        [ngClass]="{ 'nav-fases-label': true, active: localActive === i }"
        [routerLink]="link.route"
        [disabled]="link.disabled"
        [matTooltip]="navToggle && hidden ? link.label : ''"
        matTooltipClass="example-tooltip-conf"
        matTooltipPosition="after"
      >
        <mat-icon *ngIf="link.icon" [ngStyle]="{color: link.iconColor ? link.iconColor : 'black'}">{{ link.icon }}</mat-icon
        ><span [class.text-strike]="link.strike">{{ link.label }}</span>
      </button>
    </ng-container>
  </nav>
  <button
    *ngIf="navToggle"
    mat-icon-button
    class="sidenav-toggle float-right margin-top align-self-end"
    [ngClass]="{ hidden: navToggle && hidden }"
    (click)="toggleHidden()"
  >
    <mat-icon>keyboard_double_arrow_left</mat-icon>
  </button>
</div>
